import * as _ from 'lodash';
import IZoningCodesImportValidationResult = ZoneIQCalibration.IZoningCodesImportValidationResult;
import { IMapper } from 'src/app/interfaces/mappers/mapper';
import { ZoningCodesImportValidationResultModel } from 'src/app/models/calibrations/import/zoning-codes-import-validation-result.model';
import { SimpleMapper } from './simple-mapper';
import { ValidationService } from '../core/services/validation.service';
import { ZoningCodeModel } from '../models/calibrations/zoning-code-models/zoning-code.model';
import { MunicipalityMapper } from './municipality.mapper';

export class ZoningCodesImportValidationResultMapper extends SimpleMapper<
    ZoningCodesImportValidationResultModel,
    IZoningCodesImportValidationResult
> {
    protected toDTOFields: string[] = ['zoningCodesRows', 'importValidationResult'];
    protected entityConstructor = ZoningCodesImportValidationResultModel;

    fromDTO(dto: IZoningCodesImportValidationResult): ZoningCodesImportValidationResultModel {
        if (!dto) {
            return null;
        }

        const model = super.fromDTO(dto);
        const municipalityMapper = new MunicipalityMapper();

        model.zoningCodesRows = !_.isEmpty(dto.zoningCodesRows)
            ? dto.zoningCodesRows.map(zcRow => {
                  zcRow.zoningCode = zcRow.zoningCode ? ZoningCodeModel.factory(zcRow.zoningCode) : zcRow.zoningCode;
                  zcRow.municipality = zcRow.municipality
                      ? municipalityMapper.fromDTO(zcRow.municipality)
                      : zcRow.municipality;
                  zcRow.modulesStr = zcRow.modules?.map(module => module.Name).join(', ') || '';
                  return zcRow;
              })
            : [];

        model.messages = ValidationService.getImportZoningCodesValidationMessages(model);

        return model;
    }
}

export function zoningCodesImportValidationResultMapperFactory(): IMapper<
    ZoningCodesImportValidationResultModel,
    IZoningCodesImportValidationResult
> {
    return new ZoningCodesImportValidationResultMapper();
}
